/**
 * Export loadData calls from ducks modules of different containers
 */
import { loadData as AuthenticationPageLoader } from './AuthenticationPage/AuthenticationPage.duck';
import { loadData as LandingPageLoader } from './LandingPage/LandingPage.duck';
import { setInitialValues as CheckoutPageInitialValues, loadData as CheckoutPageLoadData } from './CheckoutPage/CheckoutPage.duck';
import { loadData as CMSPageLoader } from './CMSPage/CMSPage.duck';
import { loadData as ContactDetailsPageLoader } from './ContactDetailsPage/ContactDetailsPage.duck';
import { loadData as NotificationsPageLoader } from './NotificationsPage/NotificationsPage.duck';
import { loadData as EmailVerificationPageLoader } from './EmailVerificationPage/EmailVerificationPage.duck';
import { loadData as InboxBasePageLoader } from './InboxPage/InboxBasePage.duck';
import { loadData as InboxPageLoader } from './InboxPage/InboxPage.duck';
import { loadData as ListingPageLoader } from './ListingPage/ListingPage.duck';
import { loadData as ManageListingsPageLoader } from './ManageListingsPage/ManageListingsPage.duck';
import { loadData as PaymentMethodsPageLoader } from './PaymentMethodsPage/PaymentMethodsPage.duck';
import { loadData as PrivacyPolicyPageLoader } from './PrivacyPolicyPage/PrivacyPolicyPage.duck';
import { loadData as StripePayoutPageLoader } from './StripePayoutPage/StripePayoutPage.duck';
import { loadData as TermsOfServicePageLoader } from './TermsOfServicePage/TermsOfServicePage.duck';
import {
  loadData as TransactionPageLoader,
  setInitialValues as TransactionPageInitialValues,
} from './TransactionPage/TransactionPage.duck';
import { loadData as CartPageLoader } from './CartPage/CartPage.duck';
import { loadData as StoreProfilePageLoader } from './StoreProfilePage/StoreProfilePage.duck';
import { loadData as AlgoliaSearchPageLoader } from './SearchPage/AlgoliaSearchPage/AlgoliaSearchPage.duck';
import { loadData as ListingWizardPageLoader } from './ListingWizard/ListingWizardPage.duck';
import { loadData as PublishedListingPageLoader } from './PublishedListingPage/PublishedListingPage.duck';
import { loadData as BlogContentPageLoader } from './BlogContentPage/BlogContentPage.duck';
import { loadData as StoreBlogContentPageLoader } from './StoreBlogContentPage/StoreBlogContentPage.duck';
import { loadData as AIUpdateListingPageLoader } from './AIUpdateListingPage/AIUpdateListingPage.duck';
import { loadData as StoreCategoriesPageLoader } from './StoreCategoriesPage/StoreCategoriesPage.duck';
import { loadData as MediaLibraryPageLoader } from './MediaLibraryPage/MediaLibraryPage.duck';
import { setInitialValues as BlogPreviewPageInitialValues } from './BlogsPreviewPage/BlogsPreviewPage.duck';
import { loadData as AdminWalletPageLoader } from './AdminWalletPage/AdminWalletPage.duck';
import { loadData as TrustAndVerificationPageLoader } from './TrustAndVerificationPage/TrustAndVerificationPage.duck';
import { loadData as StoreBasicInformationPageLoader } from './StoreBasicInformationPage/StoreBasicInformationPage.duck';
import { loadData as StoreFaqsPageLoader } from './StoreFaqsPage/StoreFaqsPage.duck';
import { loadData as StoreHoursPageLoader } from './StoreHoursPage/StoreHoursPage.duck';
import { loadData as StoreBlogPageLoader } from './StoreBlogPage/StoreBlogPage.duck';
import { setInitialValues as StoreBlogPreviewPageInitialValues } from './StoreBlogPage/StoreBlogPreviewPage/StoreBlogPreviewPage.duck';
import { loadData as DefaultSettingsPageLoader } from './DefaultSettingsPage/DefaultSettingsPage.duck';
import { loadData as StoreListingsPageLoader } from './StoreListingsPage/StoreListingsPage.duck';

const StoreQRCodePageLoadData = (params, search, config) => (dispatch, getState) => Promise.resolve();

const getPageDataLoadingAPI = () => {
  return {
    AuthenticationPage: {
      loadData: AuthenticationPageLoader,
    },
    LandingPage: {
      loadData: LandingPageLoader,
    },
    CheckoutPage: {
      setInitialValues: CheckoutPageInitialValues,
      loadData: CheckoutPageLoadData
    },
    CMSPage: {
      loadData: CMSPageLoader,
    },
    ContactDetailsPage: {
      loadData: ContactDetailsPageLoader,
    },
    NotificationsPage: {
      loadData: NotificationsPageLoader,
    },
    EmailVerificationPage: {
      loadData: EmailVerificationPageLoader,
    },
    InboxBasePage: {
      loadData: InboxBasePageLoader,
    },
    InboxPage: {
      loadData: InboxPageLoader,
    },
    ListingPage: {
      loadData: ListingPageLoader,
    },
    ManageListingsPage: {
      loadData: ManageListingsPageLoader,
    },
    PaymentMethodsPage: {
      loadData: PaymentMethodsPageLoader,
    },
    PrivacyPolicyPage: {
      loadData: PrivacyPolicyPageLoader,
    },
    StripePayoutPage: {
      loadData: StripePayoutPageLoader,
    },
    TermsOfServicePage: {
      loadData: TermsOfServicePageLoader,
    },
    TransactionPage: {
      loadData: TransactionPageLoader,
      setInitialValues: TransactionPageInitialValues,
    },
    CartPage: {
      loadData: CartPageLoader
    },
    StoreProfilePage: {
      loadData: StoreProfilePageLoader
    },
    AlgoliaSearchPage: {
      loadData: AlgoliaSearchPageLoader
    },
    ListingWizardPage: {
      loadData: ListingWizardPageLoader
    },
    PublishedListingPage: {
      loadData: PublishedListingPageLoader
    },
    BlogPreviewPage: {
      setInitialValues: BlogPreviewPageInitialValues,
    },
    AIUpdateListingPage: {
      loadData: AIUpdateListingPageLoader
    },
    StoreCategoriesPage: {
      loadData: StoreCategoriesPageLoader
    },
    MediaLibraryPage: {
      loadData: MediaLibraryPageLoader
    },
    BlogContentPage: {
      loadData: BlogContentPageLoader
    },
    StoreBlogContentPage: {
      loadData: StoreBlogContentPageLoader
    },
    AdminWalletPage: {
      loadData: AdminWalletPageLoader
    },
    TrustAndVerificationPage: {
      loadData: TrustAndVerificationPageLoader,
    },
    StoreBasicInformationPage: {
      loadData: StoreBasicInformationPageLoader,
    },
    StoreFaqsPage: {
      loadData: StoreFaqsPageLoader,
    },
    StoreHoursPage: {
      loadData: StoreHoursPageLoader,
    },
    StoreBlogPage: {
      loadData: StoreBlogPageLoader,
    },
    StoreBlogPreviewPage: {
      setInitialValues: StoreBlogPreviewPageInitialValues,
    },
    DefaultSettingsPage: {
      loadData: DefaultSettingsPageLoader,
    },
    StoreListingsPage: {
      loadData: StoreListingsPageLoader,
    },
    StoreQRCodePage: {
      loadData: StoreQRCodePageLoadData,
    },
  };
};

export default getPageDataLoadingAPI;
